export default __webpack_public_path__ + "static/media/BecomeDriverBg.a7707acd.png";